import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

// Components
import SelectField from 'components/SelectField';
import Search from 'components/Search';

import styles from './styles.styl';

const Header = ({ className, select, search }) => (
  <div className={cn(styles.Header, className)}>
    {Array.isArray(select) ? (
      <div className={styles.Header__selects}>
        {select.map(({ name, sortType, onChange, options }) => (
          <SelectField
            key={name}
            className={styles.Header__select}
            name={name}
            value={sortType}
            onChange={onChange}
            options={options}
          />
        ))}
      </div>
    ) : (
      select && (
        <SelectField
          className={styles.Header__select}
          name={select.name}
          value={select.sortType}
          onChange={select.onChange}
          options={select.options}
        />
      )
    )}

    {search && (
      <Search
        name={search.name}
        placeholder={search.placeholder}
        isRequired={false}
        defaultValue={search.query || ''}
        handleSubmit={search.onSearch}
      />
    )}
  </div>
);

Header.defaultProps = {
  className: '',
};

const selectPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  sortType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
});

Header.propTypes = {
  className: PropTypes.string,
  select: PropTypes.oneOfType([PropTypes.arrayOf(selectPropType), selectPropType]),
  search: PropTypes.shape({
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    query: PropTypes.string,
    onSearch: PropTypes.func.isRequired,
  }),
};

export default Header;
